/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { scrollbarStyle } from "../../theme/scrollbarStyles";

import UserCard from "../cards/UserCard";

import { useState } from "react";
import { useQuery } from "react-query";
import { getPublicMembers } from "../../api/checkout/Event";
import {
  getMembers,
  getSuggestedMembers,
} from "../../api/user/community/Community";

const UserRow = ({
  selectedUsers,
  addUser,
  removeUser,
  member,
}: {
  selectedUsers: any;
  addUser: (id: string, user: any) => void;
  removeUser: (id: string) => void;
  member: any;
}) => {
  return (
    <>
      <Flex
        m="30px 0"
        alignItems="center"
        justifyContent="space-between"
        cursor="pointer"
        onClick={() => {
          if (selectedUsers.includes(member.id)) {
            removeUser(member.id);
          } else {
            addUser(member.id, {
              id: member.id,
              name: member.display_name,
              avatar: member.profile_image,
            });
          }
        }}
      >
        <UserCard
          id={member.id}
          onClick={() => {}}
          avatar={member.profile_image}
          name={member.display_name}
          location={member.region ?? "Unknown"}
          rating={member.avg_rating ?? undefined}
          isVerified={member.isVerified ?? false}
        />

        <Box
          mr="10px"
          w="14px"
          h="14px"
          borderRadius="7px"
          border={
            selectedUsers.includes(member.id) ? "none" : "1px solid #7E8B9A"
          }
          bg={selectedUsers.includes(member.id) ? "#171C22" : "transparent"}
        />
      </Flex>
    </>
  );
};

const ShareModal = ({
  isOpen,
  onClose,
  onExtendShare,
  onShare,
  title,
  isLoading,
  firebaseToken,
  exclude,
}: {
  isOpen: boolean;
  onClose: () => void;
  onShare?: (users: string[]) => void;
  isLoading?: boolean;
  title?: string;
  exclude?: string[];
  onExtendShare?: (users: any[]) => void;

  firebaseToken?: string;
}) => {
  const [search, setSearch] = useState("");

  const handleClick = () => {
    if (title === "New message" && onExtendShare) {
      onExtendShare(selectedChats);
      setSelectedUsers([]);
    } else if (onShare) {
      onShare(selectedUsers);
      setSelectedUsers([]);
    }
    onClose();
  };

  const suggestedUsers =
    firebaseToken == null
      ? useQuery(["suggestUsers"], () =>
          getSuggestedMembers({
            page: 1,
            page_size: 10,
            exclude_ids: exclude?.join(",") ?? "",
          })
        )
      : useQuery(["suggestUsers"], () =>
          getPublicMembers({
            data: {
              page: 1,
              page_size: 10,
              exclude_ids: exclude?.join(",") ?? "",
            },
            access_token: firebaseToken,
          })
        );
  const searchedUsers =
    firebaseToken == null
      ? useQuery(["searchUsers", search], () =>
          getMembers({
            search,
            page_size: 10,
            exclude_ids: exclude?.join(",") ?? "",
          })
        )
      : useQuery(["searchUsers", search], () =>
          getPublicMembers({
            data: {
              page: 1,
              page_size: 10,
              search: search,
              exclude_ids: exclude?.join(",") ?? "",
            },
            access_token: firebaseToken,
          })
        );

  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [selectedChats, setSelectedChats] = useState<any[]>([]);
  //const [message,setMessage] = useState("")

  const removeUser = (userId: string) => {
    setSelectedUsers((prevUsers) =>
      prevUsers.filter((user) => user !== userId)
    );

    setSelectedChats((prevChats) =>
      prevChats.filter((chat) => chat.id !== userId)
    );
  };

  const addUser = (userId: string, user: any) => {
    setSelectedUsers((prevUsers) => {
      if (!prevUsers.includes(userId)) {
        return [...prevUsers, userId];
      }
      return prevUsers;
    });

    setSelectedChats((prevChats) => {
      if (!prevChats.find((chat) => chat.id === userId)) {
        return [...prevChats, user];
      }
      return prevChats;
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent mx="10px">
        <ModalCloseButton />
        <ModalBody p="0 0 20px 0">
          <Center>
            <Text variant="title" fontSize="2xl" fontWeight="500" mb="20px">
              {title ?? "Share"}
            </Text>
          </Center>
          <Divider />
          <Flex alignItems="center" mt="14px" mb="5px" gap="5px">
            <Text variant="title" fontSize="lg">
              To:
            </Text>
            <Input
              variant="unstyled"
              mt="2px"
              placeholder="Search"
              _placeholder={{ color: "#7E8B9A" }}
              color="#171C22"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Flex>
          <Divider />

          {search.length == 0 && (
            <Text variant="title" fontSize="lg" fontWeight="500" mt="20px">
              Suggested
            </Text>
          )}

          <Box w="100%" h="300px" overflowY="auto" sx={scrollbarStyle}>
            {(suggestedUsers.isLoading && search.length == 0) ||
              (searchedUsers.isLoading && search.length > 0 && (
                <Center h="100%">
                  <Spinner />
                </Center>
              ))}

            {search.length == 0 &&
              suggestedUsers?.data?.profiles?.map(
                (member: any, index: number) => {
                  return (
                    <>
                      <UserRow
                        member={member}
                        key={index}
                        selectedUsers={selectedUsers}
                        addUser={addUser}
                        removeUser={removeUser}
                      />
                    </>
                  );
                }
              )}

            {search.length > 0 &&
              searchedUsers.data?.profiles.map((member: any, index: number) => {
                return (
                  <>
                    <UserRow
                      member={member}
                      key={index}
                      selectedUsers={selectedUsers}
                      addUser={addUser}
                      removeUser={removeUser}
                    />
                  </>
                );
              })}
          </Box>

          <Divider />
          <Button
            mt="20px"
            mb="10px"
            variant="light"
            w="100%"
            // onClick={() => {
            //   if (onShare) sharePost;
              
            //   if (onExtendShare) onExtendShare(selectedChats);

            //   //(onExtendShare ? onExtendShare(selectedChats) : {})
            //   setSelectedUsers([]);
            // }}
            onClick={handleClick}
            isDisabled={selectedUsers.length === 0}
            isLoading={isLoading}
          >
            {title == "New message" ? "Chat" : "Send"}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ShareModal;

